import {
  UPDATE_AI_RESULTS,
  RESET_AI_RESULTS,
  PREPEND_AI_RESULTS,
  RESET_DOCUMENT,
  NEW_AI_RESULTS,
  UPDATE_NEW_AI_RESULTS,
} from "../_actions/types";
import {isEmpty} from "lodash";

const initialState = {
  payload: [],
  page: 1,
  hasmore: false,
  newPayload: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_DOCUMENT:
    case RESET_AI_RESULTS:
      return initialState;
    case UPDATE_AI_RESULTS:
      return {
        ...state,
        payload: action.previous
          ? [...state.payload, ...action.payload]
          : action.payload,
        hasMore: action.loadMore,
        page: action.loadMore ? state.page + 1 : state.page,
      };
    case PREPEND_AI_RESULTS:
      return {
        ...state,
        newPayload: !isEmpty(state.newPayload) ? [...action.newPayload, ...state.newPayload] : action.newPayload,
      };
    case NEW_AI_RESULTS:
      return {
        ...state,
        newPayload:action.previous
        ? [...state.newPayload, ...action.newPayload]
        : action.newPayload,
      };

    default:
      return state;
  }
}